import React, { useMemo, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveUser } from "../../../Redux/Actions/userActions";
import { useEffect } from "react";
const ChangeLanguage = ({ showLanguage, setShowLanguage }) => {
  const dispatch = useDispatch();
  const [select, setSel] = useState(null);
  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }), 
    []
  );
  const user = useSelector((s) => s.user.info);
  useEffect(() => {
    if (user) {
      switch (user?.language) {
        case "hi":
          setSel(1);
          break;
        case "pu":
          setSel(2);
          break;
        case "en":
          setSel(0);
          break;
      }
    }
  }, [user]);
  function LanguageChange(lang) {
    let change = {};

    change.language = lang;

    dispatch(saveUser({ ...user, ...change }));

    i18next.changeLanguage(lang);
  }

  const VernacHandler = (language) => {
    switch (language) {
      case "हिन्दी":
        LanguageChange("hi");
        break;
      case "ਪੰਜਾਬੀ":
        LanguageChange("pu");
        break;
      case "English":
        LanguageChange("en");
        break;
    }
  };

  return (
      <Offcanvas
        show={showLanguage}
        placement="bottom"
        onHide={() => setShowLanguage(false)}
        className="h-auto bg-tr"
        {...backdrop}
      >
      <Offcanvas.Body>
        <div
          className="bi bi-x-circle fs-lg mx-auto text-white"
          onClick={() => setShowLanguage(false)}
        ></div>
        <div className="offcanvas-header">
          <h3 className="offset-title">Change Language</h3>
        </div>
        <div className="offcanvas-body bg-white p-16">
          {["English", "हिन्दी"].map((element, i) => (
            <div
              key={i}
              className={"selectArea" + (i === select ? " checked" : "")}
              onClick={() => {
                setSel(i);
                VernacHandler(element);
                setShowLanguage(false);
              }}
            >
              {element}
            </div>
          ))}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ChangeLanguage;
